import React, { useState } from 'react'
import { SiInstagram, SiGithub, SiLinkedin, SiWhatsapp, SiFacebook } from 'react-icons/si'
import '../../styles/6-Contact/Contact.css'

const Contact = () => {

  const [isOn, setIsOn] = useState(true)

  return (
    <div id='contact' className={isOn ? 'page-2 on' : 'page-2'}>
        <div className="light">
            <div className="wire"></div>
            <div className="bulb">
                <span></span>
                <span></span>
            </div>
            <div className='social-media__container'>
              <a target="_blank" href='https://www.instagram.com/dhc_anselmo11/?next=%2F'>
                <SiInstagram className={ isOn ? 'social-media__item on' : 'social-media__item' } />
              </a>
              <a target="_blank" href='https://github.com/Anselmo1122'>
                <SiGithub className={ isOn ? 'social-media__item on' : 'social-media__item' } />
              </a>
              <a target="_blank" href='https://www.linkedin.com/in/anselmo-del-hoyo-1b1b44248/'>
                <SiLinkedin className={ isOn ? 'social-media__item on' : 'social-media__item' } />
              </a>
              <a target="_blank" href='https://wa.me/+584121465184'>
                <SiWhatsapp className={ isOn ? 'social-media__item on' : 'social-media__item' } />
              </a>
              <a target="_blank" href='https://www.facebook.com/anselmo.delhoyo.33'>
                <SiFacebook className={ isOn ? 'social-media__item on' : 'social-media__item' } />
              </a>
            </div>
            <div className="switch">
                <div className="btn" onClick={()=>{
                  setIsOn(!isOn)
                }}></div>
            </div>
        </div>
    </div>
  )
}

export default Contact